import snsWebSdk from "@sumsub/websdk";
import { sumsubTokenExpirationHandler } from "./sumsubTokenExpirationHandler";
import { $sumsubApplicantStatus } from "../brickken-auth";

export enum SumsubApplicantStatusLevelName {
  InvestorTier1 = "investor-tier-1",
  TokenizerTier1 = "tokenizer-tier-1",
  TokenizerTier2 = "tokenizer-tier2"
}
export enum SumsubApplicantStatusReviewStatus {
  Init = "init",
  Pending = "pending",
  Prechecked = "prechecked",
  Queued = "queued",
  Completed = "completed",
  OnHold = "onHold"
}
export type SumsubApplicantStatus = {
  reprocessing: boolean;
  levelName: SumsubApplicantStatusLevelName;
  creationDate: string;
  expireDate: string;
  reviewStatus: SumsubApplicantStatusReviewStatus;
  autoChecked: boolean;
};

let snsWebSdkInstance;
export const initSumsub = async () => {
  const token = await sumsubTokenExpirationHandler();
  const isTokenValid = typeof token === "string";
  if (isTokenValid) {
    snsWebSdkInstance = snsWebSdk
      .init(token, sumsubTokenExpirationHandler)
      .on(
        "idCheck.onApplicantStatusChanged",
        (payload: SumsubApplicantStatus) => {
          $sumsubApplicantStatus.next(payload);
        }
      )
      .on("idCheck.onReady", (payload: SumsubApplicantStatus) => {
        console.log(payload);
        $sumsubApplicantStatus.next(payload);
      })
      .build();
    snsWebSdkInstance.launch("#sumsub-hidden");
  }
};
export const destroySumsub = () => {
  snsWebSdkInstance?.destroy();
};
